import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import { getHelpCenterUrl } from "../common/help-center-links";

const useHelpCenterUrl = (page) => {
  const { currentLanguage } = useContext(LanguageContext);
  return getHelpCenterUrl(page, currentLanguage);
};

export { useHelpCenterUrl };
